import { DvGridComponent, DvToolbarAction } from '@devinco/ui/grid';
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DvTabBase } from '@devinco/ui/legacy';
import { GridOptionsService } from '@features/vt-grid/grid-options/grid-options.service';
import { FilterModelWithKeys } from '@features/vt-grid/interfaces/grid-context';
import { Entity } from '@shared/constants/entity';
import { DirectivesModule } from '@shared/directives/directives.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions } from 'ag-grid-community';
import { UserPropertiesGridService } from './user-properties-grid.service';
import { EntityleFieldsValuesDto } from '@shared/interfaces/entity-fields-values';

@Component({
  selector: 'app-user-properties-tab',
  imports: [DvGridComponent, AgGridModule, DirectivesModule],
  providers: [GridOptionsService],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './user-properties-tab.component.html',
})
export class UserPropertiesTabComponent extends DvTabBase implements OnInit {
  private gridOptionsService = inject(GridOptionsService);
  private gridService = inject(UserPropertiesGridService);
  private cdRef = inject(ChangeDetectorRef);

  actions: DvToolbarAction[];
  gridOptions: GridOptions<EntityleFieldsValuesDto> | undefined;

  ngOnInit(): void {
    this.actions = this.gridService.getGridActions();
  }

  onBaseActions(): void {}
  onEntityCreate(): void {}
  onEntityUpdate(): void {
    if (!this.entityId) return;

    if (!this.gridOptions) {
      this.setupGridOptions();
    } else {
      this.gridOptions.context.extraFilter = this.getFilterModel(this.entityId);
      this.gridOptions.context.loadClientSideData?.(
        this.gridOptions.context.extraFilter,
        true
      );
    }
  }

  private setupGridOptions(): void {
    this.gridOptions = this.gridOptionsService.clientSide(
      this.gridService.getColumnDefs(),
      Entity.UserFieldsValues,
      this.getFilterModel(this.entityId)
    );
    this.cdRef.detectChanges();
  }

  private getFilterModel(entityId: string): FilterModelWithKeys {
    return {
      EntityID: {
        filterType: 'number',
        type: 'equals',
        filter: entityId,
      },
    };
  }
}
